import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addProduct } from 'slice/productSlice';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AddProduct = () => {
  const [formData, setFormData] = useState({
    productkey: '',
    name: '',
    price: '',
    quantity: '',
    plan_duration: '',
    images: [],
    description: ''
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.product);

 const handleChange = (e) => {
    const { name, type, files, value } = e.target;

    if (type === 'file' && name === 'images') {
        setFormData(prev => ({
            ...prev,
            images: Array.from(files)
        }));
    } else {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    }
};


const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.images.length) {
        toast('Product image is required');
        return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append('productkey', formData.productkey);
    formDataToSend.append('name', formData.name);
    formDataToSend.append('price', formData.price);
    formDataToSend.append('quantity', formData.quantity);
    formDataToSend.append('plan_duration', formData.plan_duration);
    formDataToSend.append('description', formData.description);
    formData.images.forEach((img) => formDataToSend.append('images', img));

    try {
        dispatch(addProduct(formDataToSend));
        toast('Product added successfully!');
        navigate('/products');
    } catch (error) {
        console.error('Error adding product:', error.message);
    }
};


  return (
    <>
      <div className="container-fluid mt-5">
        <div className="mainheadig mx-4">
          <h4 className="text-white font-weight-bold ">Add Medicines</h4>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="row mx-4 mt-5">
            <div className="col-sm-4 mt-2">
              <label htmlFor="productKey" className="adminlables">
                Product Key
              </label>
              <input
                type="text"
                id="productKey"
                name="productkey"
                value={formData.productkey}
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label htmlFor="productName" className="adminlables">
                Medicines Name
              </label>
              <input
                type="text"
                id="productName"
                name="name"
                value={formData.name}
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label htmlFor="productName" className="adminlables">
                Medicines Price
              </label>
              <input
                type="text"
                id="productName"
                name="price"
                value={formData.price}
                className="form-control"
                onChange={handleChange}
              />
            </div>
            {/* <div className='col-sm-4 mt-2'>
                        <label htmlFor='productName'>Product Size</label>
                        <input type='text' id='productName' name='size' defaultValue={formData.size} className='form-control' onChange={handleChange}  />
                    </div> */}
            {/* <div className='col-sm-6 mt-2'>
                        <label htmlFor='productName'>Offer (if have )</label>
                        <input type='text' id='productName' name='offer' defaultValue={formData.offer} className='form-control' onChange={handleChange} />
                    </div> */}
            <div className="col-sm-4 mt-2">
              <label htmlFor="productName" className="adminlables">
                Quantity
              </label>
              <input
                type="text"
                id="productName"
                name="quantity"
                value={formData.quantity}
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <div className="col-sm-4 mt-2">
              <label htmlFor="planDuration" className="adminlables">
                Plan Duration
              </label>
              <input
                type="text"
                id="planDuration"
                name="plan_duration"
                value={formData.plan_duration}
                className="form-control"
                onChange={handleChange}
              />
            </div>
            <div className="col-sm-12 mt-4">
              <label htmlFor="productName " className="adminlables">
                Description
              </label>
              <textarea
                rows={5}
                name="description"
                value={formData.description}
                className="form-control"
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="col-sm-12 mt-4">
              <label htmlFor="productName " className="adminlables">
                Image
              </label>
              <input
                type="file"
                id="productName"
                multiple
                name="images"
                className="form-control btn-block filebg"
                onChange={handleChange}
              />
            </div>
            {/* <div className='col-sm-6 mt-2'>
                        <label htmlFor='productName'>PDF Product</label>
                        <input type='file' id='productName' name='pdf' defaultValue={formData.pdf} className='form-control' onChange={handleChange}  />
                    </div> */}
          </div>
          <div className="mt-5 text-right mx-4 ">
            <button className="btn btn-lg addbtn" disabled={loading}>
              Add Product
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddProduct;
